"use strict";
'use strict';

var dataList = require('./data-list.cjs');



exports.Item = dataList.DataListItem;
exports.ItemLabel = dataList.DataListItemLabel;
exports.ItemValue = dataList.DataListItemValue;
exports.PropsProvider = dataList.DataListPropsProvider;
exports.Root = dataList.DataListRoot;
